var ProductIconSizes;
(function (ProductIconSizes) {
    ProductIconSizes["SM"] = "sm";
    ProductIconSizes["MD"] = "md";
})(ProductIconSizes || (ProductIconSizes = {}));
var ProductIconVariant;
(function (ProductIconVariant) {
    ProductIconVariant["GREEN"] = "green";
    ProductIconVariant["YELLOW"] = "yellow";
    ProductIconVariant["RED"] = "red";
    ProductIconVariant["BLUE"] = "blue";
    ProductIconVariant["PURPLE"] = "purple";
})(ProductIconVariant || (ProductIconVariant = {}));
export { ProductIconSizes, ProductIconVariant };
//# sourceMappingURL=ProductIcon.types.js.map